<script lang="ts">
export default {
  name: "LegalNotice",
  setup() {
    function back() {
      return history.back();
    }
    return {
      back,
    };
  },
};
</script>

<template>
  <div class="mention-legal">
    <h1 class="title">
      {{ $t("footer.legal-notice.title") }}
    </h1>
    <h2>{{ $t("footer.legal-notice.context-title") }}</h2>
    <div class="justify">
      <p class="paragraphe">
        {{ $t("footer.legal-notice.context-text") }}
      </p>
    </div>
    <h2>{{ $t("footer.legal-notice.title") }}</h2>
    <h3>{{ $t("footer.legal-notice.info-subtitle") }}</h3>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.legal-notice.info-text')"
      />
    </div>
    <h3>{{ $t("footer.legal-notice.info-publish-subtitle") }}</h3>
    <div class="justify">
      <p class="paragraphe">
        {{ $t("footer.legal-notice.info-publish-text") }}
      </p>
    </div>
    <b-button
      type="is-primary"
      @click="back"
    >
      {{ $t("footer.return") }}
    </b-button>
  </div>
</template>

<style scoped lang="scss">
.mention-legal {
  margin: 5em 8em 5em 8em;
  padding-bottom: 8em;
}
.title {
  font-size: 3em;
}

h2 {
  font-size: 2em;
}

h3 {
  font-size: 1.5em;
  font-weight: 600;
  color: $primary;
}

.justify {
  text-align: justify;
  .paragraphe {
    font-size: 1.4em;
  }
}
</style>
